export default __webpack_public_path__ + "static/media/progressBarStep4_horizontal.91f3a6fb.svg";